import styled from "@emotion/styled";

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;
